import axios from "@/api/config";

const schoolPage = {
  getHomePageListSetting(id, data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getHomePageListSetting?templateId=${id}`,
      {
        params: data
      }
    );
  },
  updateTempCover(data) {
    return axios.put(
      `${process.env.BASE_URL}/dictionary/updateDictionary`,
      data
    );
  },
  menuPageList(data) {
    return axios.post(`${process.env.BASE_URL}/schoolPageMenu/pageList`, data);
  },
  updateAgentTemp(data) {
    return axios.put(`${process.env.BASE_URL}/agentInfo/setTheme`, data);
  },
  menuSwitch(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/pageSchoolMenuSwitch`,
      {
        params: data
      }
    );
  },
  getSchoolPageMenuList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenuList`,
      {
        params: data
      }
    );
  },
  // importData(data) {
  //   return axios.post(`${process.env.BASE_URL}/agentApp/importData`, data);
  // }

  getCourseCenterGoodsPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/getCourseCenterGoodsPageList`,
      data
    );
  },
  informationPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/informationPageList`,
      data
    );
  },
  getSubjectPList(data) {
    return axios.get(`${process.env.BASE_URL}/schoolPage/getSubjectPList`, {
      params: data
    });
  },
  updateHomeSchoolPage(id, data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/updateHomeSchoolPage?templateId=${id}`,
      data
    );
  },
  getGoodsListByType(data) {
    return axios.get(`${process.env.BASE_URL}/schoolPage/getGoodsListByType`, {
      params: data
    });
  },
  addAgentCompanyInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/agentCompanyInfo/addAgentCompanyInfo`,
      data
    );
  },
  getAgentCompanyInfo(data) {
    return axios.get(
      `${process.env.BASE_URL}/agentCompanyInfo/getAgentCompanyInfo`,
      {
        params: data
      }
    );
  },
  getGeneralSettingDetail(data) {
    return axios.get(
      `${process.env.BASE_URL}/generalSetting/getGeneralSettingDetail`,
      {
        params: data
      }
    );
  },
  getCardInfoAppAndQrCode(data) {
    return axios.get(
      `${process.env.BASE_URL}/cardInfo/getCardInfoAppAndQrCode`,
      {
        params: data
      }
    );
  },
  addOrUpdateCardInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/cardInfo/addOrUpdateCardInfo`,
      data
    );
  },
  getCardInfo(data) {
    return axios.get(`${process.env.BASE_URL}/cardInfo/getCardInfo`, {
      params: data
    });
  },
  getMiniAppQrCode(data) {
    return axios.get(`${process.env.BASE_URL}/wx/user/getMiniAppQrCode`, {
      params: data
    });
  },
  studentLoginInfoPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/studentLoginInfo/pageList`,
      data
    );
  },

  getHomePageListByTemplateId(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getHomePageListByTemplateId`,
      {
        params: data
      }
    );
  },
  updateTempCover(data) {
    return axios.put(
      `${process.env.BASE_URL}/dictionary/updateDictionary`,
      data
    );
  },
  menuPageList(data) {
    return axios.post(`${process.env.BASE_URL}/schoolPageMenu/pageList`, data);
  },
  updateAgentTemp(data) {
    return axios.put(`${process.env.BASE_URL}/agentInfo/setTheme`, data);
  },
  menuSwitch(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/pageSchoolMenuSwitch`,
      {
        params: data
      }
    );
  },

  studentLoginInfoPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/studentLoginInfo/pageList`,
      data
    );
  },
  getSchoolPageMenuList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenuList`,
      {
        params: data
      }
    );
  },
  getAlreadyRelateData(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoSubjectRelation/getGoodsInfoSubjectRelationList`,
      data
    );
  },
  updateHomeSchoolPageByTemplateId(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/updateHomeSchoolPageByTemplateId`,
      data
    );
  },
  updateAgentHomeSchoolPage(data) {
    return axios.put(
      `${process.env.BASE_URL}/schoolPage/syncAgentHomeSchoolPage`,
      data
    );
  },
  synAgentSchoolPageMenu(data) {
    return axios.put(
      `${process.env.BASE_URL}/schoolPageMenu/synAgentSchoolPageMenu`,
      data
    );
  },
  //    新模块的导航设置
  getCityList(data) {
    return axios.get(
      `${process.env.BASE_URL}/dictionary/getDictionaryListByParentId`,
      {
        params: data
      }
    );
  },
  addMenu(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPageMenu/addSchoolPageMenu`,
      data
    );
  },
  getMenuList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenuList`,
      {
        params: data
      }
    );
  },

  getSchoolPageMenuListByUrl(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenuListByUrl`,
      {
        params: data
      }
    );
  },
  //    编辑和删除
  updateVideoCourse(data) {
    return axios.put(
      `${process.env.BASE_URL}/schoolPageMenu/updateSchoolPageMenu`,
      data
    );
  },
  deleteMenu(data) {
    return axios.delete(
      `${process.env.BASE_URL}/schoolPageMenu/deleteSchoolPageMenu`,
      {
        data: data
      }
    );
  },

  getMenuDetail(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenu`,
      {
        params: data
      }
    );
  },

  delRedis(data) {
    return axios.delete(`${process.env.BASE_URL}/schoolPage/delRedis`, {
      data: data
    });
  },
  getSchoolPageTemplatePageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPageTemplate/pageList`,
      data
    );
  },

  updateSchoolPageTemplate(data) {
    return axios.put(
      `${process.env.BASE_URL}/schoolPageTemplate/updateSchoolPageTemplate`,
      data
    );
  }
};

export default schoolPage;



// WEBPACK FOOTER //
// ./src/api/schoolPage.js